<div class="savviva-container">
	<mat-sidenav-container class="sidenav-container" #container>
		<mat-sidenav [opened]="isLogin" [position]="'start'" [mode]="'side'" [disableClose]='true' class="sidenav-container__menu">
			<div class='sidenav-container__logo'>
				<img src='assets/login-logo.svg'>
			</div>
			<cactussoft-accordion-menu
				[menuLinks]="slideMenuLinks"
				(loginSource)="logout()">
			</cactussoft-accordion-menu>
		</mat-sidenav>
		<mat-sidenav-content>
			<cactussoft-breadcrumb></cactussoft-breadcrumb>
			<router-outlet></router-outlet>
		</mat-sidenav-content>
	</mat-sidenav-container>
	<ng-progress [color]="'#232628'"></ng-progress>
</div>
